import { SystemIcon } from "@shared/designSystem/SystemIcon";
import { Text } from "@shared/designSystem/Texts";
import designSystemStyles from "@shared/styles/designSystemStyles";
import styles from "@shared/styles/components/SelectionPill.module.css";

interface SelectionPillProps {
    label: string;
    onRemove: () => void;
    disabled?: boolean;
    className?: string;
    ariaLabel?: string;
}

export const SelectionPill: React.FC<SelectionPillProps> = ({
    label,
    onRemove,
    disabled = false,
    className,
    ariaLabel,
}) => {
    return (
        <span className={[styles.pill, disabled ? styles.disabled : "", "DSSelectionPill", className].filter(Boolean).join(" ")}>
            <Text text={label} truncate={true} className={styles.label} />
            <button
                type="button"
                className={styles.removeButton}
                onClick={onRemove}
                disabled={disabled}
                aria-label={ariaLabel ?? `${"Eliminar".localized()} ${label}`}
            >
                <SystemIcon
                    type="close"
                    size="small"
                    color={disabled ? designSystemStyles.colorTextSecondary : designSystemStyles.colorText}
                />
            </button>
        </span>
    );
};
